// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Control_Monad_Writer_Trans from "../Control.Monad.Writer.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Lazy from "../Data.Lazy/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Debug from "../Debug/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Foliage_App_Console_Component from "../Foliage.App.Console.Component/index.js";
import * as Foliage_App_Editor_Component from "../Foliage.App.Editor.Component/index.js";
import * as Foliage_App_Style from "../Foliage.App.Style/index.js";
import * as Foliage_App_Viewer_Component from "../Foliage.App.Viewer.Component/index.js";
import * as Foliage_Common from "../Foliage.Common/index.js";
import * as Foliage_Example_Typing from "../Foliage.Example.Typing/index.js";
import * as Foliage_Interpretation from "../Foliage.Interpretation/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML from "../Halogen.HTML/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_Query from "../Halogen.Query/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe from "../Unsafe/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var slot = /* #__PURE__ */ Halogen_HTML.slot();
var editorIsSymbol = {
    reflectSymbol: function () {
        return "editor";
    }
};
var slot1 = /* #__PURE__ */ slot(editorIsSymbol)(Data_Ord.ordUnit);
var viewerIsSymbol = {
    reflectSymbol: function () {
        return "viewer";
    }
};
var slot2 = /* #__PURE__ */ slot(viewerIsSymbol)(Data_Ord.ordUnit);
var consoleIsSymbol = {
    reflectSymbol: function () {
        return "console";
    }
};
var slot3 = /* #__PURE__ */ slot(consoleIsSymbol)(Data_Ord.ordUnit);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Halogen_Query_HalogenM.bindHalogenM);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM);
var tell = /* #__PURE__ */ Halogen_Query.tell();
var tell1 = /* #__PURE__ */ tell(viewerIsSymbol)(Data_Ord.ordUnit);
var tell2 = /* #__PURE__ */ tell(consoleIsSymbol)(Data_Ord.ordUnit);
var pure = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var bind = /* #__PURE__ */ Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Halogen_Query_HalogenM.functorHalogenM);
var request = /* #__PURE__ */ Halogen_Query.request()(editorIsSymbol)(Data_Ord.ordUnit);
var log = /* #__PURE__ */ Effect_Class_Console.log(/* #__PURE__ */ Halogen_Query_HalogenM.monadEffectHalogenM(Effect_Aff.monadEffectAff));
var bindExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Halogen_Query_HalogenM.monadHalogenM);
var composeKleisli = /* #__PURE__ */ Control_Bind.composeKleisli(bindExceptT);
var discard2 = /* #__PURE__ */ discard(bindExceptT);
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT)(Halogen_Query_HalogenM.monadHalogenM);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Halogen_Query_HalogenM.monadHalogenM));
var monadExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.monadExceptT(Halogen_Query_HalogenM.monadHalogenM);
var interpModule = /* #__PURE__ */ Foliage_Interpretation.interpModule(/* #__PURE__ */ Control_Monad_Writer_Trans.monadWriterT(Data_Monoid.monoidArray)(monadExceptT))(/* #__PURE__ */ Control_Monad_Writer_Trans.monadWriterWriterT(Data_Monoid.monoidArray)(monadExceptT))(/* #__PURE__ */ Control_Monad_Writer_Trans.monadThrowWriterT(Data_Monoid.monoidArray)(/* #__PURE__ */ Control_Monad_Except_Trans.monadThrowExceptT(Halogen_Query_HalogenM.monadHalogenM)));
var traceM = /* #__PURE__ */ Debug.traceM()(Halogen_Query_HalogenM.monadHalogenM);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Foliage_Common["_Show_Exc"]({
    reflectSymbol: function () {
        return "error";
    }
}));
var EditorOutput = /* #__PURE__ */ (function () {
    function EditorOutput(value0) {
        this.value0 = value0;
    };
    EditorOutput.create = function (value0) {
        return new EditorOutput(value0);
    };
    return EditorOutput;
})();
var ViewerOutput = /* #__PURE__ */ (function () {
    function ViewerOutput(value0) {
        this.value0 = value0;
    };
    ViewerOutput.create = function (value0) {
        return new ViewerOutput(value0);
    };
    return ViewerOutput;
})();
var ConsoleOutput = /* #__PURE__ */ (function () {
    function ConsoleOutput(value0) {
        this.value0 = value0;
    };
    ConsoleOutput.create = function (value0) {
        return new ConsoleOutput(value0);
    };
    return ConsoleOutput;
})();
var default_mod = Foliage_Example_Typing.example;
var _viewer = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var _editor = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var _console = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var component = /* #__PURE__ */ (function () {
    var render = function (state) {
        return Halogen_HTML_Elements.div([ Foliage_App_Style.style([ "width: 100%", "background-color: rgba(10, 43, 54, 0.0)" ]) ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.padding_big)(append(Foliage_App_Style.flex_column)([ "align-items: center" ]))) ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(append([ "height: 2em" ])(append([ "vertical-align: center", "text-align: center" ])(append(Foliage_App_Style.font_fancy)(Foliage_App_Style.underline)))) ])([ Halogen_HTML_Core.text("Foliage") ]), Halogen_HTML_Elements.div([ Foliage_App_Style.style(append([ "width: calc(100vw - 2em)", "height: calc(100vh - 5em)" ])(append(Foliage_App_Style.flex_row)([ "gap: 0" ]))) ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(append([ "height: 100%", "width: 50%", "overflow: scroll" ])(Foliage_App_Style.flex_column)) ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.padding_small) ])([ slot1(_editor)(Data_Unit.unit)(Foliage_App_Editor_Component.component)({
            mod: new Data_Maybe.Just(Data_Lazy.force(default_mod))
        })(EditorOutput.create) ]) ]), Halogen_HTML_Elements.div([ Foliage_App_Style.style(append([ "height: 100%", "width: 50%", "overflow: scroll" ])(Foliage_App_Style.flex_column)) ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.padding_small) ])([ slot2(_viewer)(Data_Unit.unit)(Foliage_App_Viewer_Component.component)({
            mod: state.mod
        })(ViewerOutput.create) ]) ]), Halogen_HTML_Elements.div([ Foliage_App_Style.style(append([ "height: 100%", "width: 50%", "overflow: scroll" ])(Foliage_App_Style.flex_column)) ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.padding_small) ])([ slot3(_console)(Data_Unit.unit)(Foliage_App_Console_Component.component)({})(ConsoleOutput.create) ]) ]) ]) ]) ]);
    };
    var initialState = function (_input) {
        return {
            mod: Data_Lazy.force(default_mod)
        };
    };
    var handleAction = function (v) {
        if (v instanceof EditorOutput) {
            return discard1(modify_(function (v1) {
                var $57 = {};
                for (var $58 in v1) {
                    if ({}.hasOwnProperty.call(v1, $58)) {
                        $57[$58] = v1[$58];
                    };
                };
                $57.mod = v.value0.value0;
                return $57;
            }))(function () {
                return discard1(tell1(_viewer)(Data_Unit.unit)(Foliage_App_Viewer_Component.SetResult.create(Data_Maybe.Nothing.value)))(function () {
                    return discard1(tell2(_console)(Data_Unit.unit)(Foliage_App_Console_Component.SetLogs.create([  ])))(function () {
                        return pure(Data_Unit.unit);
                    });
                });
            });
        };
        if (v instanceof ViewerOutput) {
            return bind(mapFlipped(request(_editor)(Data_Unit.unit)(Foliage_App_Editor_Component.GetModule.create))(Unsafe.fromJust("editor must exist")))(function (mod) {
                return discard1(tell1(_viewer)(Data_Unit.unit)(Foliage_App_Viewer_Component.SetResult.create(new Data_Maybe.Just(Foliage_App_Viewer_Component.PendingResult.value))))(function () {
                    return discard1(log("[App.run]"))(function () {
                        return discard1(bind(Control_Monad_Except_Trans.runExceptT(composeKleisli(Control_Monad_Writer_Trans.runWriterT)(function (v1) {
                            return discard2(lift(tell2(_console)(Data_Unit.unit)(Foliage_App_Console_Component.SetLogs.create(v1.value1))))(function () {
                                return pure1(v1.value0);
                            });
                        })(interpModule(mod))))(function (v1) {
                            if (v1 instanceof Data_Either.Left) {
                                return discard1(traceM(show(v1.value0)))(function () {
                                    return tell1(_viewer)(Data_Unit.unit)(Foliage_App_Viewer_Component.SetResult.create(new Data_Maybe.Just(new Foliage_App_Viewer_Component.ErrResult({
                                        err: v1.value0,
                                        env: Data_Maybe.Nothing.value
                                    }))));
                                });
                            };
                            if (v1 instanceof Data_Either.Right) {
                                if (v1.value0.value0 instanceof Data_Maybe.Nothing) {
                                    return tell1(_viewer)(Data_Unit.unit)(Foliage_App_Viewer_Component.SetResult.create(new Data_Maybe.Just(new Foliage_App_Viewer_Component.OkResult({
                                        env: v1.value0.value1
                                    }))));
                                };
                                if (v1.value0.value0 instanceof Data_Maybe.Just) {
                                    return tell1(_viewer)(Data_Unit.unit)(Foliage_App_Viewer_Component.SetResult.create(new Data_Maybe.Just(new Foliage_App_Viewer_Component.ErrResult({
                                        err: v1.value0.value0.value0,
                                        env: new Data_Maybe.Just(v1.value0.value1)
                                    }))));
                                };
                                throw new Error("Failed pattern match at Foliage.App.Component (line 74, column 17 - line 76, column 138): " + [ v1.value0.value0.constructor.name ]);
                            };
                            throw new Error("Failed pattern match at Foliage.App.Component (line 69, column 15 - line 76, column 138): " + [ v1.constructor.name ]);
                        }))(function () {
                            return pure(Data_Unit.unit);
                        });
                    });
                });
            });
        };
        if (v instanceof ConsoleOutput) {
            if (v.value0 instanceof Foliage_App_Console_Component.ShowIntermediateEnv) {
                return discard1(tell1(_viewer)(Data_Unit.unit)(Foliage_App_Viewer_Component.SetIntermediateEnv.create(new Data_Maybe.Just(v.value0.value0))))(function () {
                    return pure(Data_Unit.unit);
                });
            };
            if (v.value0 instanceof Foliage_App_Console_Component.HideIntermediateEnv) {
                return discard1(tell1(_viewer)(Data_Unit.unit)(Foliage_App_Viewer_Component.SetIntermediateEnv.create(Data_Maybe.Nothing.value)))(function () {
                    return pure(Data_Unit.unit);
                });
            };
            throw new Error("Failed pattern match at Foliage.App.Component (line 78, column 29 - line 84, column 18): " + [ v.value0.constructor.name ]);
        };
        throw new Error("Failed pattern match at Foliage.App.Component (line 48, column 18 - line 84, column 18): " + [ v.constructor.name ]);
    };
    var $$eval = Halogen_Component.mkEval({
        handleQuery: Halogen_Component.defaultEval.handleQuery,
        receive: Halogen_Component.defaultEval.receive,
        initialize: Halogen_Component.defaultEval.initialize,
        finalize: Halogen_Component.defaultEval.finalize,
        handleAction: handleAction
    });
    return Halogen_Component.mkComponent({
        initialState: initialState,
        "eval": $$eval,
        render: render
    });
})();
export {
    default_mod,
    EditorOutput,
    ViewerOutput,
    ConsoleOutput,
    component,
    _viewer,
    _editor,
    _console
};
